import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Helper/Loader";
import ApiService from "../Service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { setRegisterData } from "../Redux/UserSlice";
const ResendOtp = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [seconds, setSeconds] = useState(30)
    const registerData = useSelector(state => state?.userData?.registerData)
    const businessToken = useSelector(state => state?.userData?.business_token)

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1)
            }
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [seconds])

    const [form, setForm] = useState({
        phone: props?.form?.phone,
        country_code: props?.form?.country_code
    })

    const LoginApi = async () => {
        try {
            setLoading(true)
            const data = await ApiService.request('post', ApiService.config.checkEmailSendOtpApi,
                { email: registerData?.email, business_token: businessToken }
            )
            if (data?.status) {
                toast.success(data?.message)
                // dispatch(setRegisterData({ email: data?.data?.email, slug: '' }))
                navigate('/verify-otp')
                setSeconds(30)
            } else {
                toast.error(data?.message)
            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            {seconds > 0 ?
                <div className="font-primary font-16px  mb-3 pb-xl-1">Resend OTP in 00:{seconds > 9 ? seconds : "0" + seconds}</div>
                :
                <div className="font-primary font-16px  mb-3 pb-xl-1">
                    <a className="link-primary text-decoration-underline mb-3" style={{ 'whiteSpace': 'nowrap' }} onClick={() => {
                        LoginApi()
                    }}>
                        Resend OTP
                    </a>
                </div>
            }
        </>
    )
}
export default ResendOtp;